<template>
  <FilledLoader />
</template>

<script>
import FilledLoader from '@/decast/components/common/FilledLoader.vue';


export default {
  data() {
    return {
    };
  },
  components: {
  },
  mounted() {
    document.getElementById('loading-bg').style.display = 'block';
    this.loginWithMagicLink();
  },
  methods: {
    loginWithMagicLink() {
      const payload = {
        hash: this.$route.query.hash,
      };
      this.$store
        .dispatch('auth/v2loginWithMagicLink', payload)
        .then((response) => {
          const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
          if (isTwoFactorAuthEnabled) {
            //ask for 2fa
            const twoFactorToken = response.data?.token;
            this.$router.push({ name: 'TwoFactor', query: { tempToken: twoFactorToken } });
          } else {
            this.$store.commit('auth/SET_LOGGEDIN', true);
            this.$acl.change('user');
            this.$vs.notify({
              title: 'Login Successful',
              text: 'Redirecting to dashboard!',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success',
            });
            this.$router.push('/dashboard/rooms');
          }
        })
        .catch((error) => {
          // Safely extract the specific error message
          const errorResponse = error.response?.data;
          let message = "An error occurred.";
          if (errorResponse?.errors?.email) {
            message = "Account does not exist!";
          } else if (errorResponse?.errors?.password) {
            message = errorResponse?.errors?.password;
          } else if (typeof errorResponse?.errors === 'string') {
            message = errorResponse.errors;
          }
          this.$vs.notify({
            title: 'Failed to send reset link',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        }).finally(() => {
          document.getElementById('loading-bg').style.display = 'none';
        });
    },
  }
}
</script>

<style scoped>
*:not(i) {
  /* font-family: 'Karla', sans-serif !important; */
  font-family: 'Rethink Sans' !important;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

#checkbox {
  width: unset !important;
  margin-top: 0px !important;
  margin-right: 10px !important;
  width: 16px !important;
  height: 16px !important;
  cursor: pointer;
}

.pmc-right {
  position: relative;
  overflow: hidden;
  width: 80%;
  height: 100%;
  padding: 70px 70px 0px 70px;
}

.pmc-right p {
  color: #FFFFFF;
}

.pmc-right h1 {
  color: #FFFFFF;
  font-size: 40px;
  line-height: 120%;
}

.pmc-right h1 span {
  color: #D7DF23;
}

.pmc-right .pmc-right-p1 {
  color: #BCBCBC;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 24px;
  cursor: pointer;
}

.pmc-right label {
  font-size: 14px;
  color: #FFFFFF;
}

.pmc-right input {
  background: #15161F;
  border: 1px solid #444551;
  color: #FFFFFF;
  padding: 0.75rem !important;
  border-radius: 8px !important;
  width: 100% !important;
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
  margin-top: 6px;
}

.pmc-right button {
  background: #D7DF23;
  border: 1px solid #D7DF23;
  color: #000000;
  padding: 0.75rem;
  border-radius: 12px;
  width: 100%;
  outline: 2px solid transparent;
  outline-offset: 2px;
  cursor: pointer;
  transition: transform 0.05s ease-in-out;
}

.pmc-right button:active {
  transform: scale(0.99);
}

.password-div-wrapper {
  margin-top: 6px;
  position: relative;
}

.password-div-wrapper input {
  margin-top: 6px;
  margin-top: 0px;
}

.password-div-wrapper span {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: pointer;
}

.check-box-label {
  color: #BCBCBC;
  font-size: 12px;
}

.sep-line {
  background-color: #444551;
  opacity: 0.5;
}

.sep-line-label {
  color: #FFFFFF50;
  background-color: #1B1D29;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}

p.text-lime-400 {
  color: #D7DF23;
  display: inline-block;
  margin-top: 12px;
}

@media (max-width: 1024px) {
  .pmc-right {
    width: 100%;
    padding: 70px 40px;
  }
}

@media (max-width: 768px) {}

@media (max-width: 480px) {
  .pmc-right {
    padding: 20px;
  }
}
</style>
